import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'tkSlice'
})
export class TkSlicePipe implements PipeTransform {

  transform(text: string | undefined, maxLength = 25): string {
    return text ? text.slice(0, maxLength) + (text.length >= maxLength ? '...' : '') : '';
  }
}
